<app-loading-spinner></app-loading-spinner>
<app-toaster-stack></app-toaster-stack>

<!-- Global Logout Confirmation Modal -->
<app-confirmation-modal
  [showModal]="showLogoutModal"
  title="Confirm Logout"
  message="Are you sure you want to logout?"
  confirmText="Logout"
  cancelText="Cancel"
  (confirmed)="onLogoutConfirmed()"
  (cancelled)="onLogoutCancelled()">
</app-confirmation-modal>

<!-- Payment Status Modal -->
<app-payment-status-modal
  [show]="showPaymentStatusModal"
  [status]="paymentStatus || 'success'">
</app-payment-status-modal>
<ng-container *ngIf="!isLoginPage() && !isVolunteerPage() && !isNgoPage() && !isCorporatePage() && !isForgotPasswordPage() && !isLandingPage() && !isTermsPrivacyPolicyPage() ; else otherLayout">
  <app-main-layout>
    <router-outlet></router-outlet>
  </app-main-layout>
</ng-container>
<ng-template #otherLayout>
  <ng-container *ngIf="isVolunteerPage() && !isOnboardingPage(); else ngoOrNoSidebar">
    <app-volunteer-layout>
      <router-outlet></router-outlet>
    </app-volunteer-layout>
  </ng-container>
  <ng-template #ngoOrNoSidebar>
    <ng-container *ngIf="isNgoPage() && !isOnboardingPage(); else noSidebar">
      <app-ngo-layout>
        <router-outlet></router-outlet>
      </app-ngo-layout>
    </ng-container>
    <ng-template #noSidebar>
      <router-outlet></router-outlet>
    </ng-template>
  </ng-template>
</ng-template>
